
import React, { useRef, useEffect, useState, Fragment } from 'react'
import {Row, Col, Button, Form, OverlayTrigger, Tooltip, Card, Container, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux'
import { Auth, LoadingComponent } from 'recupero-comunes'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import { obtenerConsultaHonorarios } from '../../store/actions/solicitud-honorarios-action'
import { formatoMontoCLP } from '../../common/Formatos'
import ModalEditarHonorario from './modalEditarHonorario';
import ModalSolicitudCambioMontoHonorario from './modalSolicitudCambioMonto';
import ModalDetalleHonorario from './modalDetalleHonorario';
import { CarpetaDigitalComponent} from 'defcol-caso-general'

const BandejaHonorarios = ({selectedRows, setSelectedRows}) => {  

    const AGRUPACION_ESTADO_HONO_DISPONIBLE = 1;

    const dispatch = useDispatch()
    const [loading, setLoading]=useState(false)
    const data_solitudHonorarios = useSelector((state) => state.solicitudHonorariosReducer)
    const {cfg_form97, consultaHonorarios} = data_solitudHonorarios

    const [showModalDetalle, setShowModalDetalle] = useState(false);
    const [showModalEditar, setShowModalEditar] = useState(false);
    const [showModalSolicitudCambioMonto, setShowModalSolicitudCambioMonto] = useState(false);
    const [listaGrilla, setListaGrilla] = useState('');

    const [selectedRow, setSelectedRow] = useState({});

    const [showCarpeta, setShowCarpeta] = useState(false)
    const handleShowCarpeta = () => setShowCarpeta(true)
    const handleCloseCarpeta= () => setShowCarpeta(false)

    const handleCloseModalDetalleHo = () => {
        setShowModalDetalle(false)
    }
    const handleCloseModalSolicitudCambioMonto = () => {
        setShowModalSolicitudCambioMonto(false);
        handleReload();
    }
    const handleCloseModalEditar = () => {
        setShowModalEditar(false)
        handleReload();
    }

    useEffect(()=>{
        setSelectedRows([])
        setListaGrilla(consultaHonorarios && consultaHonorarios.consultaHonorarios)
    },[consultaHonorarios])

    const stringDate2Time = (date) => {
        date = date.split("-");
        return new Date( date[2], date[1] - 1, date[0]).getTime();
    }
    const verDetalleHonorario = (row) => {       
        setSelectedRow(row);
        setShowModalDetalle(true);
    }
    const verCambioMonto = (row) => {
        setSelectedRow(row);
        setShowModalSolicitudCambioMonto(true);        
    }   
    const verEditarHonorario = (row) => {
        setSelectedRow(row);
        setShowModalEditar(true);
    }   
    const verCarpeta = (row) => {
        setSelectedRow(row);
        handleShowCarpeta();
    }
    
    const obtenerColumnas = () => {

        return [

            { 
                dataField: 'idSolicitud', text: cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-sol']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'siniestro', text: cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-sini']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'patente', text: cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-placa']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'glosaConcepto', text: cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-concepto']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'fechaHabilitadoFmt', text: cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-fechahab']:'', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'fechaSolicitudFmt', text: cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-fechasol']:'', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },            
            { 
                dataField: 'montoNetoFacturado', text: cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-monto']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}, formatter: formatoMontoCLP
            },
            { 
                dataField: 'nroFactura', text: cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-numfact']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
             { 
                dataField: 'glosaSituacion', text: cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-situacion']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            {
                dataField: 'accion', text:cfg_form97 ? cfg_form97.cfg_form97['busqueda-solicitud-honorarios-grilla-accion']:'' , isDummyField: true,  headerAlign: 'center', align: 'center' ,
                
                formatter: (cell, row) => (
                    <div>
                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver detalle Honorarios</Tooltip>}>
                        <Button type="button" variant="subir me-md-2" size="sm" onClick={ () => verDetalleHonorario(row) }>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                            </svg>
                        </Button>
                        </OverlayTrigger>
                        {/*<OverlayTrigger overlay={<Tooltip id="tooltip-disabled">
                            {row.agrupacionEstado == AGRUPACION_ESTADO_HONO_DISPONIBLE ? "Editar Honorario" : "Acción no disponible"}
                        </Tooltip>}>
                        <Button type="button" variant="subir me-md-2" size="sm" 
                            onClick={ () => verEditarHonorario(row) }
                            disabled={row.agrupacionEstado !== AGRUPACION_ESTADO_HONO_DISPONIBLE}
                            className={row.agrupacionEstado !== AGRUPACION_ESTADO_HONO_DISPONIBLE ? "btn-inactivo" : "btn-activo"}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                            </svg>
                        </Button>                        
                        </OverlayTrigger>*/}
                        <OverlayTrigger overlay={<Tooltip id="tooltip-carpeta">Carpeta Digital</Tooltip>}>
                            <Button
                                type="button"
                                variant="subir me-md-2"
                                size="sm"
                                onClick={() => { verCarpeta(row);}}
                                name="carpeta"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-folder2-open" viewBox="0 0 16 16">
                                    <path d="M1.5 3a.5.5 0 0 0-.5.5V4h14v-.5a.5.5 0 0 0-.5-.5h-7.086a.5.5 0 0 1-.354-.146l-.707-.708A1 1 0 0 0 6.086 2H1.5zm14 2H.5a.5.5 0 0 0-.491.592l1.5 8A.5.5 0 0 0 2 14h12a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 15.5 5z"/>
                                </svg>
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">
                            {row.agrupacionEstado == AGRUPACION_ESTADO_HONO_DISPONIBLE ? "Cambiar Monto Honorario" : "Acción no disponible"}
                        </Tooltip>}>
                        <Button type="button" variant="subir me-md-2" size="sm" 
                            onClick={ () => verCambioMonto(row) }
                            disabled={row.agrupacionEstado !== AGRUPACION_ESTADO_HONO_DISPONIBLE}
                            className={row.agrupacionEstado !== AGRUPACION_ESTADO_HONO_DISPONIBLE ? "btn-inactivo" : "btn-activo"}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-currency-dollar" viewBox="0 0 16 16">
                            <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73z"/>
                            </svg>
                        </Button>
                        </OverlayTrigger>
                    </div>
                )
                , headerStyle:{color:'white', backgroundColor:'#7594C1',verticalAlign: 'middle', width: '150px'}, style: { width: '150px' }
            }
        ]
    }
    const obtenerExcelGrilla= () => {

        
    }
    const handleReload = () => {
        if (consultaHonorarios && consultaHonorarios.query) {
            setLoading(true);
            let query = consultaHonorarios.query;
            dispatch(obtenerConsultaHonorarios(query)).then(() => {
                setLoading(false);
            });
        }
    }

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        selected: selectedRows.map(r => r.Id),
        onSelect: (row, isSelect) => {
            if (row.agrupacionEstado !== 1) return false; // No permitir selección
            if (isSelect) {
                setSelectedRows(prev => [...prev, row]);
            } else {
                setSelectedRows(prev => prev.filter(r => r.Id !== row.Id));
            }
        },
        onSelectAll: (isSelect, rows) => {
            if (isSelect) {
                const selectableRows = rows.filter(r => r.agrupacionEstado === 1);
                setSelectedRows(selectableRows);
            } else {
                setSelectedRows([]);
            }
        },
        getCheckboxProps: row => {            
            return {
                disabled: row.agrupacionEstado !== 1
            };
        }
    };
    return (
        <>
        <div>
            <style type='text/css'>
            {`
                .btn-subir {
                background-color: #00aeab;
                color: #FFFFFF;   
                height:40px;

                }
                .btn-subir:hover{
                    background-color:#01cec8;
                    color: #FFFFFF;
                    
                } 
                .react-bootstrap-table .react-bootstrap-table-select-all {
                    background-color: #7594C1 !important;
                    color: white !important;
                    text-align: center;
                }
                .btn-activo {
                    background-color: #00aeab !important; /* turquesa sólido */
                    border: none !important;
                    color: #fff !important;
                }

                .btn-activo:hover {
                    background-color: #01cec8 !important; /* hover un poco más claro */
                    color: #fff !important;
                }
                .btn-inactivo {
                    background-color: #77c0c0ff !important; /* turquesa clarito */
                    border: none !important;
                    color: #fff !important;
                    cursor: not-allowed !important;
                }
            `}
            </style>
            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">              
                <CarpetaDigitalComponent
                    handleClose={handleCloseCarpeta}
                    idCaso={selectedRow?.idCaso}
                    idImplicado={selectedRow?.idImplicado || 1}
                    idOrganizacionCaso={selectedRow?.idCompania}
                    prototipo={2}
                />               
            </Modal>
            <LoadingComponent show={loading} />
            <Container>  
                { cfg_form97 ?
                    <div>  
                        <Card >
                            <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white', textAlign:'center' }}>
                                {cfg_form97
                                    ? `${cfg_form97.cfg_form97['busqueda-solicitud-honorarios-resultado']} (${consultaHonorarios && consultaHonorarios.consultaHonorarios !==undefined ? consultaHonorarios.consultaHonorarios.length : 0})`
                                    : ''} 
                            </Card.Header>
                            <ToolkitProvider search bootstrap4 keyField="Id" 
                                data={ listaGrilla ? listaGrilla : [] } 
                                columns={ obtenerColumnas() } defaultSorted={ [{ dataField: 'Id', order: 'asc' }] }>
                                { 
                                props =>                   
                                    <div>
                                        
                                        <Row>
                                            <Col md={4} className="d-grid gap-2 d-md-flex justify-content-md-start mt-2 mb-2">
                                                <Button className="mx-2" type="button" variant="success" size="sm" onClick={() => { obtenerExcelGrilla() }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-excel" viewBox="0 0 16 16">
                                                    <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"/>
                                                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                                                    </svg>
                                                </Button>
                                            </Col>                           
                                            <Col md={8} className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2">
                                                
                                                <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }}/>
                                                <Button className="mx-2" type="button" variant="outline-info" size="sm" onClick={() => { handleReload() }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                                    </svg>
                                                </Button>
                                            
                                            </Col>                           
                                        </Row>                        
                                        <BootstrapTable
                                            {...props.baseProps}
                                            headerWrapperClasses="table-secondary"
                                            pagination={paginationFactory()}
                                            noDataIndication={<div className="text-center">No hay registros encontrados</div>}
                                            selectRow={selectRow}   // 👈 ahora sí sobrescribe el que venga de baseProps
                                        />
                                    </div>
                                }
                            </ToolkitProvider>
                        </Card>
                    </div>
        
                : null }
            </Container>
        </div>
        
            <ModalDetalleHonorario
                showModalDetalle={showModalDetalle}
                handleCloseModalDetalleHo={handleCloseModalDetalleHo}
                selectedRow={selectedRow}        
            />
            <ModalEditarHonorario
                showModalEditar={showModalEditar}
                handleCloseModalEditar={handleCloseModalEditar}
                selectedRow={selectedRow}        
            />
            <ModalSolicitudCambioMontoHonorario
                showModalSolicitudCambioMonto={showModalSolicitudCambioMonto}
                handleCloseModalSolicitudCambioMonto={handleCloseModalSolicitudCambioMonto}
                selectedRow={selectedRow}        
            />
        </>
    );
}
export default BandejaHonorarios